/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import authenticationReducer from './authentication';
import blockReducer from './block';
import schoolReducer from './school';
import jobReducer from './job';
import jobOrionReducer from './job-orion';
import disciplineReducer from './discipline';
import eventReducer from './event';
import trainingReducer from './training';
import pageReducer from './page';
import groupReducer from './group';

/**
 * List all reducers
 */

const authenticationPersistConfig = {
    key: 'authentication',
    storage: localForage,
    whitelist: ['user', 'token'],
};

const blockPersistConfig = {
    key: 'block',
    storage: localForage,
};

const schoolPersistConfig = {
    key: 'school',
    storage: localForage,
};

const jobPersistConfig = {
    key: 'job',
    storage: localForage,
};

const jobOrionPersistConfig = {
    key: 'jobOrion',
    storage: localForage,
};

const disciplinePersistConfig = {
    key: 'discipline',
    storage: localForage,
};

const eventPersistConfig = {
    key: 'event',
    storage: localForage,
};

const trainingPersistConfig = {
    key: 'training',
    storage: localForage,
};

const pagePersistConfig = {
    key: 'page',
    storage: localForage,
};

const groupPersistConfig = {
    key: 'group',
    storage: localForage,
};

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        notifications: notificationsReducer(),
        authentication: persistReducer(
            authenticationPersistConfig,
            authenticationReducer
        ),
        block: persistReducer(blockPersistConfig, blockReducer),
        school: persistReducer(schoolPersistConfig, schoolReducer),
        job: persistReducer(jobPersistConfig, jobReducer),
        jobOrion: persistReducer(jobOrionPersistConfig, jobOrionReducer),
        discipline: persistReducer(disciplinePersistConfig, disciplineReducer),
        event: persistReducer(eventPersistConfig, eventReducer),
        training: persistReducer(trainingPersistConfig, trainingReducer),
        page: persistReducer(pagePersistConfig, pageReducer),
        group: persistReducer(groupPersistConfig, groupReducer),
    });
